import { ReactKeycloakProvider } from "@react-keycloak/web";
import React, { useEffect, useState } from "react";
import App from "./App";
import keycloak from "../../../keycloak/keycloak";
import { onKeycloakEvent } from "../../../keycloak/keycloakFunctions";
import NotificationUtils from "../../../utils/NotificationUtils";
import { setCekomTheme, getCekomLogo, getDefaultLogo } from "../Theme";

const AppContainer = () => {
  const [state, setState] = useState({ logo: undefined });

  const setTheme = installationName => {
    switch (installationName) {
      case "CEKOM":
        setCekomTheme();
        setState({ logo: getCekomLogo() });
        break;
      default:
        setState({ logo: getDefaultLogo() });
        break;
    }
  };

  useEffect(() => {
    NotificationUtils.requestForNotificationsPermission();
    setTheme(process.env.REACT_APP_INSTALLATION);
  }, []);

  return (
    <ReactKeycloakProvider
      authClient={keycloak}
      onEvent={onKeycloakEvent(keycloak)}
    >
      <App config={{ delay: 300 }} logo={state.logo} />
    </ReactKeycloakProvider>
  );
};

export default AppContainer;
